module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ds-calendar"
  }, [(_vm.isYear) ? _c('div', {
    staticClass: "ds-month-view ds-year-view"
  }, [_c('ds-weeks-view', _vm._g(_vm._b({
    staticClass: "ds-expand",
    attrs: {
      "calendar": _vm.calendar,
      "placeholder": _vm.placeholder,
      "placeholder-for-create": _vm.placeholderForCreate
    },
    on: {
      "mouse-move-day": _vm.mouseMoveDay,
      "mouse-down-day": _vm.mouseDownDay,
      "mouse-up-day": _vm.mouseUp,
      "mouse-up-event": _vm.mouseUp,
      "mouse-down-event": _vm.mouseDownEvent,
      "clear-placeholder": _vm.clearPlaceholder
    }
  }, 'ds-weeks-view', {
    $scopedSlots: _vm.$scopedSlots
  }, false), _vm.$listeners))], 1) : _vm._e(), _vm._v(" "), (_vm.isMonth) ? _c('div', {
    staticClass: "ds-month-view"
  }, [_c('ds-weeks-view', _vm._g(_vm._b({
    staticClass: "ds-expand",
    attrs: {
      "calendar": _vm.calendar,
      "placeholder": _vm.placeholder,
      "placeholder-for-create": _vm.placeholderForCreate
    },
    on: {
      "mouse-move-day": _vm.mouseMoveDay,
      "mouse-down-day": _vm.mouseDownDay,
      "mouse-up-day": _vm.mouseUp,
      "mouse-up-event": _vm.mouseUp,
      "mouse-down-event": _vm.mouseDownEvent,
      "clear-placeholder": _vm.clearPlaceholder
    }
  }, 'ds-weeks-view', {
    $scopedSlots: _vm.$scopedSlots
  }, false), _vm.$listeners))], 1) : _vm._e(), _vm._v(" "), (_vm.isWeek || _vm.isDay) ? _c('div', {
    staticClass: "ds-week-view"
  }, [_c('ds-days-view', _vm._g(_vm._b({
    attrs: {
      "calendar": _vm.calendar,
      "placeholder": _vm.placeholder,
      "placeholder-for-create": _vm.placeholderForCreate
    },
    on: {
      "mouse-move": _vm.mouseMove,
      "mouse-down": _vm.mouseDown,
      "mouse-up": _vm.mouseUp,
      "mouse-down-event": _vm.mouseDownEvent,
      "mouse-move-day": _vm.mouseMoveDay,
      "mouse-down-day": _vm.mouseDownDay,
      "mouse-up-day": _vm.mouseUp,
      "mouse-up-event": _vm.mouseUp,
      "clear-placeholder": _vm.clearPlaceholder
    }
  }, 'ds-days-view', {
    $scopedSlots: _vm.$scopedSlots
  }, false), _vm.$listeners))], 1) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5325b506","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Calendar.vue
// module id = 170
// module chunks = 0